<template>
  <div>
    <template v-if="pistil_history_data_loading === 1">
      <h2>Loading ...</h2>
    </template>
    <template v-else>
      <div class="inventory-container">
        <h3>
          {{ pistil_history_data.title.company_name }} - {{ pistil_history_data.title.type_details }}
        </h3>

        <table class="inventory-table">
          <thead>
          <tr>
            <th class="sticky-th">Date</th>
            <th
                v-for="pid in pistil_history_data.headers"
                :key="pid"
                class="sticky-th"
            >
              {{ pistil_history_data.products[pid] || `Product ${pid}` }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="date in pistil_history_data.dates"
              :key="date"
              :class="{ 'order-row': isOrderRow(date) }"
          >
            <td class="date-cell" v-html="formatDateDisplay(date)"></td>
            <td
                v-for="pid in pistil_history_data.headers"
                :key="pid"
                class="inventory-cell"
                :class="{ 'order-value': isOrderRow(date) }"
            >
              {{ getValue(date, pid) }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      pistil_history_data: 'admin/pistil_history_data',
      pistil_history_data_loading: 'admin/pistil_history_data_loading',
    }),
  },
  props: {
    customer_id: null,
    category: null,
  },
  mounted() {
    this.GetPistilData();
  },
  methods: {
    GetPistilData() {
      if (this.customer_id == null) {
        this.customer_id = 1841900;
        this.category = 1;
      }
      this.$store.dispatch('admin/getPistilProductInventoryHistory', {
        'customer_id': this.customer_id,
        'category': this.category,
        'start_date': '2026-01-01',
        'end_date': '2037-04-04'
      });
    },

    isOrderRow(date) {
      return typeof date === 'string' && date.indexOf(' ') !== -1;
    },

    formatDateDisplay(date) {
      if (typeof date === 'string' && date.indexOf(' ') !== -1) {
        var parts = date.split(' ');
        var datePart = parts[0];
        var orderId = parts[1];
        return datePart + '<br><span style="font-size:12.5px; color:#1976d2; font-weight:500;">Order #' + orderId + '</span>';
      }
      return date;
    },

    getValue(date, pid) {
      if (!this.pistil_history_data || !this.pistil_history_data.data) {
        return '—';
      }

      var dataObj = this.pistil_history_data.data;
      var realKey = date;

      if (typeof date === 'string' && date.indexOf(' ') !== -1) {
        var parts = date.split(' ');
        var originalDate = parts[0];
        var orderId = parts[1];
        realKey = originalDate + '_order_' + orderId;
      }

      if (dataObj[realKey] && typeof dataObj[realKey][pid] !== 'undefined') {
        return dataObj[realKey][pid];
      }

      return '—';
    }
  }
}
</script>

<style scoped>
.inventory-container {
  width: 100%;
}

.inventory-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

.inventory-table th,
.inventory-table td {
  border: 1px solid #ccc;
  padding: 8px 10px;
  text-align: center;
  vertical-align: middle;
  font-size: 13.5px;
}

.sticky-th {
  position: sticky;
  top: 57px;
  background-color: #f0f0f0;
  font-weight: 600;
  z-index: 100;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
}

.date-cell {
  font-weight: bold;
  background-color: #f8f8f8;
  text-align: left;
  width: 180px;
  padding: 10px 12px !important;
  vertical-align: top;
  line-height: 1.5;
}

/* Order row styling */
.order-row {
  background-color: #e3f2fd;
}

.order-row .date-cell {
  color: #1565c0;
}

/* Blue + bold quantities on order rows */
.order-value {
  color: #1565c0 !important;
  font-weight: 700 !important;
}

.inventory-cell {
  min-width: 88px;
  white-space: nowrap;
}

.inventory-table tr:hover {
  background-color: #f9f9f9;
}
</style>
